export function getWidgetName(variant = '') {
  if (!variant) return 'product-carousel/root';

  switch (variant) {
    case 'OMNIPROJECT-477':
      return 'product-carousel/sponsored';
    case 'original':
    default:
      return 'product-carousel/root';
  }
}
